import React from "react";
import { useTheme } from "@mui/material";

interface IProps {
  title?: string;
  children: React.ReactNode;
  level: number;
  style?: React.CSSProperties;
}

const Section = ({ title, children, level, style }: IProps) => {
  const theme = useTheme()

  return (
    <div className="display-grid gap-1"
         style={{
           padding: "2px",
           gridTemplateRows: "auto 1fr",
           justifyItems: "stretch",
           alignItems: "stretch",
           background: "rgba(0, 0, 0, .1)",
           ...style
         }}>
      {title && <strong style={{ fontSize: 16 - level, color: theme.palette.text.secondary }}>{title}</strong>}
      <div className="display-grid" style={{ borderTop: title ? "1px solid rgba(130, 130, 130, .1)" : undefined }}>
        {children}
      </div>
    </div>
  );
}

export default Section;